<template>
  <el-dialog width="500px" title="设置联系电话" :visible.sync="innerVisible" class="setPhone-dialog-style" append-to-body
    :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog">
    <el-form :model="phoneForm" ref="phoneForm" label-width="100px" v-loading='setPhoneLoading'>
      <el-form-item label="联系电话" prop="phone" :rules="phoneRules" class="phoneForm-style">
        <el-input v-model.trim="phoneForm.phone" autocomplete="off"></el-input>
      </el-form-item>
      <span class="tip-style">提示：客户管家App/PC发起工单、处理问题件、发起理赔将优先带入此处设置的联系电话。</span>
      <div class="btn-style">
        <el-button @click="resetPhoneForm('phoneForm')" plain>取消</el-button>
        <el-button type="primary" @click="submitPhoneForm('phoneForm')">保存</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { getAfterOrderPromoterPhoneApi, updatePromoterPhoneApi } from '@/api/afterSaleService/eComAfterSaleMgr/afterSaleOrder';
// import netAPI from '@/api';
export default {
  name: '',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  created() {
  },
  data() {

    let valiTel = (rule, value, callback) => {
      let reg1 = /^([1]\d{10})$/;
      let reg2 = /^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/;
      if (
        (!(reg1.test(value)) && !(reg2.test(value))) &&
        value !== ''
      ) {
        return callback(new Error('格式不正确，请输入手机号或座机号'));
      }
      callback();
    };
    return {
      innerVisible: this.isShow,

      setPhoneLoading: false,
      phoneForm: {
        phone: ''
      },
      phoneRules: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        { validator: valiTel, trigger: 'blur' }
      ],
    };
  },
  watch: {
  },
  mounted() {
    this.innerVisible = this.isShow;
    if (this.innerVisible) {
      this.setPhone();
    }
  },
  methods: {
    setPhone() {
      this.setPhoneLoading = true;
      getAfterOrderPromoterPhoneApi().then(res => {
        if (res.message === 'ok') {
          this.phoneForm.phone = res.data || '';
        } else {
          this.phoneForm.phone = '';
        }
        this.setPhoneLoading = false;
      }).catch(() => {
        this.phoneForm.phone = '';
        this.setPhoneLoading = false;
      });
    },
    // 设置联系电话dialog取消设置
    resetPhoneForm(formName) {
      this.$refs[formName].resetFields();
      this.closeDialog();
    },
    // 设置联系电话dialog提交
    submitPhoneForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updatePromoterPhoneApi(this.phoneForm.phone).then(res => {
            if (res.message === 'ok') {
              this.$message.success('设置成功');
              this.closeDialog();
            } else {
              this.$message.error(res.error || '设置失败');
            }
          }).catch(() => {
            this.$message.error('设置失败');
          });
        } else {
          return false;
        }
      });
    },
    closeDialog() {
      this.innerVisible = false;
      this.$emit('refreshPhone');
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.setPhone-dialog-style {
  .phoneForm-style {
    width: 400px;
  }
  .tip-style {
    font-size: 13px;
    color: #999;
  }

  .btn-style {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 20px;
    .el-button {
      width: 80px;
    }
  }
  
}
</style>
